import { type___locale___translations___collection } from "../types/types.locale";

//	E X P O R T   L O C A L E   -->   funcs_measurements

export const locale___funcs_measurements: type___locale___translations___collection = {
	'unit___pz': {
		de_de: '/ Stk',
		en_us: '/ pcs',
		es_es: '/ uds',
		fr_fr: '/ pcs',
		it_it: '/ pz'
	},
	'unit___pz___extended': {
		de_de: 'pro Stück',
		en_us: 'per Piece',
		es_es: 'por Pieza',
		fr_fr: 'par Pièce',
		it_it: 'al Pezzo'
	},
	'unit___g': {
		de_de: '/ g',
		en_us: '/ g',
		es_es: '/ g',
		fr_fr: '/ g',
		it_it: '/ g',
	},
	'unit___g___extended': {
		de_de: 'pro gramm',
		en_us: 'per gram',
		es_es: 'por gramo',
		fr_fr: 'par gramme',
		it_it: 'al grammo',
	},
	'unit___hg': {
		de_de: "/ 100 g",
		en_us: "/ 100 g",
		es_es: "/ 100 g",
		fr_fr: "/ 100 g",
		it_it: "/ etto"
	},
	'unit___hg___extended': {
		de_de: "pro 100 Gramm",
		en_us: "per 100 Grams",
		es_es: "por 100 Gramos",
		fr_fr: "pour 100 Grammes",
		it_it: "all'etto"
	},
	'unit___kg': {
		de_de: '/ kg',
		en_us: '/ kg',
		es_es: '/ kg',
		fr_fr: '/ kg',
		it_it: '/ kg',
	},
	'unit___kg___extended': {
		de_de: 'pro kilo',
		en_us: 'per kilo',
		es_es: 'por kilo',
		fr_fr: 'par kilo',
		it_it: 'al chilo',
	},
	'unit___l': {
		de_de: '/ l',
		en_us: '/ l',
		es_es: '/ l',
		fr_fr: '/ l',
		it_it: '/ l',
	},
	'unit___l___extended': {
		de_de: 'pro liter',
		en_us: 'per liter',
		es_es: 'por litro',
		fr_fr: 'par litre',
		it_it: 'al litro',
	},
};